// import { EnumIntegerValue } from "./integerenumvalue";
// import { EnumStringValue } from "./stringenumvalue";
// import { EnumBoolValue } from "./boolenumvalue";

export interface CheckboxIEnumValue{
    getEnumValueName():string;
    getEnumValue():any;

    /**
     * 值显示
     */
    value:string;
}

export class CheckboxEnumValue implements CheckboxIEnumValue{

    getEnumValueName():string{
        return this.name;
    }

    getEnumValue():any{
        return this.value;
    }
    
    /**
     * 文本显示
     */
    name:string;

    /**
     * 值显示
     */
    value:string;
}